export const localStorageConstants = {
  redirectUrl: 'redirectUrl',
};
